var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":"bottom","trigger":"hover"}},[_c('vue-qr',{attrs:{"text":_vm.Url,"size":150}}),_c('el-button',{attrs:{"slot":"reference","type":"text","icon":"el-icon-share"},slot:"reference"},[_vm._v("分享")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }